import { Offers } from '@dgx-pr-spa/shared/util';
import { createReducer, on } from '@ngrx/store';
import * as fromOffers from '../actions/offers.action';
import { StateSlice } from '@core/helpers/state-slice';

export type OffersState = StateSlice<Offers>;

export const initialState: OffersState = {
  data: {} as Offers,
  loaded: false,
  loading: false,
  error: null,
};

const offersReducer = createReducer(
  initialState,
  on(fromOffers.loadOffersSuccess, (state, { payload }) => {
    const replacements = JSON.parse(
      JSON.stringify(payload?.replacement_offers || [])
    );
    if (replacements) {
      replacements.map(
        (item, i) => (item.uniqueId = `${i}/${item.article_id}`)
      );
    }
    const data = Object.assign({}, payload);
    data.replacement_offers = replacements;
    return {
      ...state,
      loading: false,
      loaded: true,
      data,
    };
  }),
  on(fromOffers.loadOffersFail, (_, { payload }) => {
    return {
      ...initialState,
      error: payload,
    };
  }),
  on(fromOffers.resetOffers, () => {
    return {
      ...initialState,
    };
  })
);

export function reducer(
  state: OffersState | undefined,
  action: fromOffers.OffersActions
) {
  return offersReducer(state, action);
}
